import { APIServiceCovid } from "../apis/apiservices";

const apiService = new APIServiceCovid();

const wsm = {
  data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.imagesize.height = "52%";
      this.imagesize.width = "20%";
    },
    getGridDtl(drow) {
      this.getStateDtl(drow);
    },

    async getStateDtl(drow) {
      this.isLoading = false;
      const url = `https://api.covid19india.org/state_district_wise.json`;

      this.state = drow.state;
      this.statedtl = await apiService.getDataIndiaStateDtl(url, drow.state);
      this.statedtl = apiService.filterState(this.statedtl, drow.state);
      this.statedtl = apiService.flattenO(this.statedtl, "District");
      this.mgcolumns = ["District", "active", "activePct", "confirmed", "deceased", "deceasedPct", "recovered", "recoveredPct"];
      this.isLoading = true;
    },

    getSelection1(wri) {
      // (wri === "w")
      //   ? ((this.worldrcntry === "world") ? `Selection: World` : `Selection: Country - ${this.clist} - ${this.cdate}`)
      //   : this.ddetails.state;
      if (wri === "w") {
        return ((this.worldrcntry === "world") ? `Selection: World` : `Selection: Country - ${this.clist} - ${this.cdate}`);
      }
      return this.ddetails.state;
    },

    setTitle(rtitle) {
    //   // const { title } = vm.$options;
    //   // console.log("here I am title", vm.$options);
    //   // let rtitle;
    //   // if (rtitle) {
    //   //   rtitle = typeof title === 'function' ? title.call(vm) : title;
    //   // }
      // const rtitle = "Test Title";
      document.title = rtitle;
    //   return rtitle;
    }
  },
};

export default wsm;
